export { browserIdRegexp } from './browserId.regexp';
export { creditCardExpirationRegexp } from './creditCardExpiration.regexp';
export { cvvRegexp } from './cvv.regexp';
export { passwordRegexp } from './password.regexp';
export { phoneRegexp } from './phone.regexp';
